module.exports = __webpack_public_path__ + "6a22c7a81fa220da342c68df835e4c0f.woff2";